<template>
<v-card>
  <request-status :request="req" @ok="step=1" />
  <v-card-title class='overline py-1 grey lighten-4' >
    <slot name="card-title" >{{title}}
      <v-spacer/>
      <v-btn @click="$emit('close')" small icon ><v-icon>mdi-close</v-icon></v-btn>
    </slot>
  </v-card-title>
  <v-divider/>
  <v-card-text>
    <v-window v-model="step" vertical >
      <v-window-item >
        <slot name="card-text" ></slot>
      </v-window-item >

      <v-window-item >
        <slot name="card-text-success" >
          <center>
          <v-icon :size="70" color="green" class="mt-5" >mdi-check-circle</v-icon><br/>
          <div class="title py-3" v-text="successmessage" />
          <slot name="card-text-success-actions" >
            <v-btn @click="$emit('done')" large outlined >Done</v-btn>
          </slot>
          </center>
        </slot>
      </v-window-item >
    </v-window>
  </v-card-text>
  <v-card-actions v-if="step===0" >
    <slot name="card-actions" >
      <v-spacer />
      <v-btn @click="save"
      :loading="req.loading"
      :color="ctaColor" >{{ctaText}}</v-btn>
    </slot>
  </v-card-actions>
</v-card>
</template>
<script>
export default {
  name: 'ActionComponent',
  props: {
    value: { type: Object, required: true },
    payload: { type: Object, required: true },
    successmessage: { type: String, default: 'Success!' },
    title: { type: String, default: 'Are you sure?' },
    ctaText: { type: String, default: 'Save' },
    ctaColor: { type: String, default: 'primary' }
  },
  data () {
    return {
      step: 0,
      req: {
        resource: '',
        resourceId: '',
        status: 0,
        loading: true
      }
    }
  },
  watch: {
    value: {
      immediate: true,
      handler () { this.req = this.value }
    },
    requestStatus () {
      this.$emit(`status${this.requestStatus}`, this.req)
      if (this.requestStatus >= 200 && this.requestStatus < 300) {
        this.$emit('ok', this.req)
      }
    }
  },
  computed: {
    requestStatus () { return this.req.status }
  },
  methods: {
    save () {
      this.req.data = this.payload
      this.$emit('save', this.req)
      this.$request('save', this.req)
    }
  }
}
</script>
